import { render, staticRenderFns } from "./MapVehicleDetails.vue?vue&type=template&id=2fffac3c&scoped=true"
import script from "./MapVehicleDetails.vue?vue&type=script&lang=js"
export * from "./MapVehicleDetails.vue?vue&type=script&lang=js"
import style0 from "./MapVehicleDetails.vue?vue&type=style&index=0&id=2fffac3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fffac3c",
  null
  
)

export default component.exports